
  import { Component, OnInit, ViewChild, ChangeDetectorRef, Output } from '@angular/core';
  import { FormGroup, FormControl, FormBuilder, Validators, NgForm } from '@angular/forms';
  import { AuthenticationService, Item, TestData, Category, Complexity, Type } from '../services/authentication.service';
  import { Router } from '@angular/router';
  import { MediaMatcher } from '@angular/cdk/layout';
  import { TestSchedulerService } from '../services/test_scheduler.service';
  import { MatPaginator } from '@angular/material/paginator';
  import { QuestionSetService, QuestionSet, Pattern } from '../services/questionset.service';
  import { TestTakerService } from '../services/test_taker.service';
  import { MaterialModule } from '../material.module';
  import {NgbTimepickerConfig, NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
  import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
  import {MatSortModule, MatSort} from '@angular/material/sort';
  import { Schedule } from '../scheduletest/scheduletest.model';
  import { EditModalComponent } from '../edit-modal/edit-modal.component';
  import { MatTableDataSource } from '@angular/material/table';
  import Swal from 'sweetalert2';
  import { DatePipe } from '@angular/common';

  @Component({
    templateUrl: './scheduledtest_view.component.html',
    styleUrls: ['./scheduledtest_view.component.scss'],
    providers: [NgbTimepickerConfig]
  })
  export class ScheduleTestViewComponent {
    @Output() editnew;
    fieldArray: Array<Schedule> = [];
    fieldarr:any=[];
    row1:any;
    searchKey = '';
    startDate: Date | null = null;
    endDate: Date | null = null;
    displayedColumns: string[] = ['collegeName','year','questionSet','scheduledDate','startTime','endTime','actions'];
    dataSource = new MatTableDataSource<any>([]);
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    newAttribute: any = {};
    time: NgbTimeStruct;
    date: NgbDateStruct;
    // date;
    model;
    resultRes: boolean;
    view:any=[]
    filterArray: any[] = [];
    details: boolean;
    // view;
    fname;
    lname;
    pageIndex: number = 0;
    user;
    isCustomStyleApplied: boolean = false;
    screenWidth: number | undefined;
    screenHeight: number | undefined;
    candidate;
    result1: boolean;
    userAdmin: boolean;
    userSuperAdmin: boolean;
    userTestScheduler: boolean;
    userTestTaker: boolean;
    displayTable:boolean = true;
    pageSize = 5;
    questionset: boolean;
    scheduletest: boolean;
    mobileQuery: MediaQueryList;
    selected;
    overall: boolean;
    localEditData: any;
    evaluate: boolean;
    Pattern;
    private _mobileQueryListener: () => void;

    test: TestData = {
      id: '',
      FirstName: '',
      LastName: '',
      Email: '',
      Phone: '',
      Type: ''
    };
    question_set: QuestionSet = {
      Question_Set_Name: ''
    };

    pattern: Pattern = {
      pattern: ''
    };

    scheduleTest = new FormGroup({
      candidatename: new FormControl(''),
      questionsetname: new FormControl(''),
      pattern: new FormControl(''),
      date: new FormControl(''),
      time: new FormControl('')
    });

    myForm: FormGroup;
    userEvaluator: boolean;
    
    constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router, private qs: QuestionSetService,
                private testtakerservice: TestTakerService, private testschedulerservice: TestSchedulerService,
                changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, config: NgbTimepickerConfig, private modalService: NgbModal,private datePipe: DatePipe) {
                  config.seconds = true;
                  config.spinners = false;

                  this.scheduledtest_view();
                  this.getAccess();
                  this.simpletest();
                  this.mobileQuery = media.matchMedia('(max-width: 600px)');
                  this._mobileQueryListener = () => changeDetectorRef.detectChanges();
                  this.mobileQuery.addListener(this._mobileQueryListener);
                  this.createForm();
                  this.fieldarr=JSON.parse(localStorage.getItem('field'));
                  this.getScreenSize();
                  this.applyStylesBasedOnResolution();
    }
    ngOnInit() {
      // Assuming yourDataArray is your array of data
      this.scheduledtest_view();

  
  }
    getScreenSize(): void {
      this.screenWidth = window.innerWidth;
    
      this.screenHeight = window.innerHeight;
    
    }

    applyStylesBasedOnResolution(): void {
      if (this.screenWidth && this.screenHeight) {
      
        if (this.screenWidth < 1366 && this.screenHeight <  641) {
          this.isCustomStyleApplied = true;
          
        
        }
      
      }
    }
    
    
    onPageSizeChange(value: string) {
      this.pageSize = +value; // Convert the string to a number
    }
    createForm() {
      this.myForm = this.fb.group({
        date: ['', Validators.required ],
      
      });
    }
  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

    simpletest() {
      this.testschedulerservice.test_scheduler(this.test).subscribe(
      (data) => {

      this.candidate = data.results;
      this.user = sessionStorage.getItem('user');
      this.fname = sessionStorage.getItem('fname');

      this.lname = sessionStorage.getItem('lname');


      },
      err => {
        console.error(err);
      }
    );
    }

    selectChangeHandler(event: any) {

      this.selected = event.target.value;

  console.log("this.selected",this.selected);
      this.qs.scheduledtest_view(this.selected).subscribe(
        (data) => {

          this.view = data.results;
        
            console.log(this.view,"this.viewin test view");
        },
        err => {
          console.error(err);
        }
      );
  }

    scheduledtest_view() {
    console.log("this.fieldArray",this.fieldArray )  // field array empty
      this.qs.scheduledtest_viewall(this.fieldArray).subscribe(
        (data) => {

          this.view = data.results;
          this.dataSource = new MatTableDataSource<any>(this.view);
          console.log(this.dataSource,"this.dataSource");
          this.dataSource.sort = this.sort;
          this.filterArray =this.dataSource.data;
          this.dataSource.sortingDataAccessor = (data, sortHeaderId) => {
        switch (sortHeaderId) {
          case 'collegeName':
            return data.College_Name;
          case 'year':
            return data.Year;
          case 'questionSet':
            return data.Question_Set_Name;
          case 'scheduledDate':
            return data.Start_Date;
          case 'startTime':
            return data.Start_Time;
          case 'endTime':
            return data.End_Time;
          default:
            return data[sortHeaderId];
        }
      };
          this.dataSource.paginator = this.paginator;
          
          console.log(this.view,"this.viewin viewall");
          
        },
        err => {
          console.error(err);
        }
      );
      }

      OnAddScheduletest() {

        this.router.navigateByUrl('/schedule_test');
      }
      onPageChange(event: any): void {
        this.pageIndex = event.pageIndex; 
        console.log("pageIndex",this.pageIndex);
      }
      
      delete(set ,index: number) {
  console.log(set,"set");
  console.log(index,"index");
  index= index + this.pageIndex * 5;
  Swal.fire({
    title: 'Are you sure want to delete?',
    text: 'You will not be able to recover later!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.isConfirmed) {
        this.qs.delete_schedule(set).subscribe(
        
          (data) => {
            if (data.code === 200) {
              Swal.fire({
              title: 'Success',
              text: data.success,
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((resultRes) => {
              console.log(this.view,"view");
              this.view.splice(index,1)
              this.dataSource = new MatTableDataSource(this.view);
              this.dataSource.paginator = this.paginator;
            })
          
          } else if (data.code === 400) {
            Swal.fire({
              title: 'TRY AGAIN',
            text: data.failed,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK'
          }).then((resultRes) => {
              // if (result.isConfirmed) {
              //     this.router.navigateByUrl('/test_scheduler');
              //  }
            })

        
          }
            
            
          });
      }
    })
  }



    applyFilter(refresh: boolean = false) {

      if (refresh) {
        console.log("inside refresh")
        this.scheduledtest_view(); // Assuming this function fetches the full data
        this.startDate = null;
        this.endDate = null;
        this.displayTable = true;
      }
      this.dataSource.filter = '';
      
    
      if (this.startDate && this.endDate) {
        // Set time to midnight for filterStartDate
        const filterStartDate = new Date(this.startDate);
        filterStartDate.setHours(0, 0, 0, 0);
      
        // Set time to midnight for filterEndDate
        const filterEndDate = new Date(this.endDate);
        filterEndDate.setHours(0, 0, 0, 0);
        
        // Apply date range filter
        this.dataSource.data = this.filterArray.filter(item => {
          const itemDate = new Date(item.Start_Date);
          
          // Set time to midnight for itemDate
          itemDate.setHours(0, 0, 0, 0);
      
          console.log("itemDate:", itemDate);
          console.log("filterStartDate:", filterStartDate);
          console.log("filterEndDate:", filterEndDate);
      
          return itemDate >= filterStartDate && itemDate <= filterEndDate;
        });
        if(this.dataSource.data.length === 0){
          this.displayTable = false;
        }
        else{
          this.displayTable = true;
        }
      }
      

      // Reapply paginator after filtering
      this.dataSource.paginator = this.paginator;
    }
  
      openEditModal(row) {
        console.log("row",row);
      
        const modalRef = this.modalService.open(EditModalComponent,
          {
            scrollable: true,
            windowClass: 'myCustomModalClass',
            // keyboard: false,
            backdrop: 'static'
          });
          // modalRef.componentInstance.editData = row;
          // modalRef.componentInstance.editData = this.editnew;
        modalRef.componentInstance.setEditData(row);
        modalRef.result.then((result) => {
          this.qs.scheduledtest_viewall(this.fieldArray).subscribe(
            (data) => {
      
              this.view = data.results;
              this.dataSource = new MatTableDataSource(this.view);
              this.dataSource.sort = this.sort;
              this.dataSource.paginator = this.paginator;
            
              console.log(this.view,"this.viewin viewall");
              //
            },
            err => {
              console.error(err);
            }
          );
        }, (reason) => {
        });
      }
  }
